import React from 'react';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';

import Components from '../components';
import './cover.scss';

const Cover = (props) => {
  const wrapperClasses = ['cover-wrapper'];
  const coverClasses = ['cover'];

  if (props.blok.half_height) {
    wrapperClasses.push('half-height');
    coverClasses.push('half-height');
  } else if (props.blok.peek_content_below) {
    wrapperClasses.push('almost-full-height');
    coverClasses.push('almost-full-height');
  } else {
    wrapperClasses.push('full-height');
    coverClasses.push('full-height');
  }

  coverClasses.push('valign-' + props.blok.vertical);
  coverClasses.push('halign-' + props.blok.horizontal);

  const contentClasses = ['content'];
  contentClasses.push('valign-' + props.blok.vertical);
  contentClasses.push('halign-' + props.blok.horizontal);

  let backgroundStyle = {};

  if (
    props.blok.background_color &&
    props.blok.background_color.color &&
    props.blok.background_color.color !== '#f40000'
  ) {
    backgroundStyle['backgroundColor'] = props.blok.background_color.color;
  }

  if (props.blok.background_image && props.blok.background_image.filename) {
    backgroundStyle['backgroundImage'] = `url('${props.blok.background_image.filename}')`;
  }

  return (
    <Wrapper style={backgroundStyle} className={wrapperClasses.join(' ')}>
      <SbEditable content={props.blok}>
        <section className={coverClasses.join(' ')}>
          <div className={contentClasses.join(' ')}>
            {props.blok.body.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
          </div>
        </section>
      </SbEditable>
    </Wrapper>
  );
};

export default Cover;

const Wrapper = styled.div`
  width: 100vw;
  max-width: 100%;
  background-position: center center;
  background-size: cover;
`;
